import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=78736d4f&scoped=true"
import script from "./CategoryModal.vue?vue&type=script&lang=ts"
export * from "./CategoryModal.vue?vue&type=script&lang=ts"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=78736d4f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78736d4f",
  null
  
)

export default component.exports